import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthHandler } from '@cr-driver/handler/auth.handler';
import { map, take } from 'rxjs';

export const canActivate: CanActivateFn = () => {
  const authHandler = inject(AuthHandler);
  const router = inject(Router);

  return authHandler.loggedIn.pipe(
    take(1),
    map((isLoggedIn) => {
      if (isLoggedIn) return true;

      void router.navigate(['/login']);
      return false;
    }),
  );
};

export const canActivateChild: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => canActivate(route, state);
